module.exports = __webpack_public_path__ + "img/pic_19.770ed877.jpg";